import {
  CollapseCustom as AntdCollapseCustom,
  CollapsePanelCustom as AntdCollapsePanelCustom,
} from "@empglabs/backoffice-ui-kit"

export const CollapseCustom = props => {
  return <AntdCollapseCustom {...props} />
}

export const CollapsePanelCustom = props => {
  return <AntdCollapsePanelCustom {...props} />
}
